(function () {
    'use strict';

    angular.module("imApp").factory("travelWageSetsService", ['$ihttp', function ($ihttp) {
        let service = {
            listTravelWageSets: function (parms) {
                return $ihttp.post({
                    method: 1494,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
